import React from 'react';

import getColor, { ColorName } from 'happytree';

import { IconName } from '../../../Icon';
import { ButtonBaseProps } from '../ButtonBase';
import * as S from './Button.styles';

export enum ButtonSize {
  Size24 = '24px',
  Size32 = '32px',
  Size40 = '40px',
  Size48 = '48px',
}

export type Props = Omit<ButtonBaseProps, 'height' | 'hasCenterRipple'> & {
  size?: ButtonSize;
  color?: ColorName;
  isLoading?: boolean;
};

function Button(
  {
    size = ButtonSize.Size32,
    isSelected = false,
    children = null,
    color = 'neutral',
    isLoading = false,
    ...props
  }: Props,
  ref: Props['ref'],
) {
  const rippleActiveColor = getColor(color, -2);

  const rippleHoverColor = isSelected
    ? getColor(color, -2)
    : getColor(color, -1);

  const loadingIconSize = size === ButtonSize.Size24 ? 14 : 20;

  return (
    <S.Button
      ref={ref}
      buttonColor={color}
      buttonSize={size}
      isSelected={isSelected}
      rippleActiveColor={rippleActiveColor}
      rippleHoverColor={rippleHoverColor}
      {...props}
    >
      <S.LoadingIcon
        isVisible={isLoading}
        loading={true}
        size={loadingIconSize}
        type={IconName['load-c']}
      />
      <S.ButtonContent isVisible={!isLoading}>{children}</S.ButtonContent>
    </S.Button>
  );
}

export default React.forwardRef(Button);
